export const COMPANY_LEGAL_NAME = "RVL Labs";
export const COMPANY_CNPJ = "55.907.983/0001-36";
export const COMPANY_COUNTRY = "Brasil";
export const COMPANY_WEBSITE = "https://rvllabs.com.br";
export const COMPANY_WEBSITE_LABEL = "rvllabs.com.br";

export const CONTACT_EMAIL = "contato@menuzai.com";
export const PRODUCT_WEBSITE = "https://menuzai.com";
export const PRODUCT_WEBSITE_LABEL = "menuzai.com";
